import AttendeeView from './AttendeeView';

export default AttendeeView;